import { PopperContent } from '@/components/poppers/PopperContent';

export function GiftTaxDrag() {
  return (
    <PopperContent
      body={`Tax drag is the amount of annual return assumed to be used to pay taxes on investment income. Enter a value between 0-100%. For example, if a $1,000,000 portfolio has a 10% pre-tax return and a 20% tax drag, then 20% of the $100,000 pre-tax investment return, or $20,000, is assumed to be the tax due on the portfolio's investment income.`}
    />
  );
}
